import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { ACTION_LABELS } from 'dashboard/constants/gch';

// "Regresar IA" and "Reiniciar" are triggered by adding an action label that
// the automations forward to the bridge.
export function useAiHandoff() {
  const store = useStore();
  const { t } = useI18n();

  const applyActionLabel = async (conversation, label) => {
    const labels = conversation.labels || [];
    if (labels.includes(label)) return;

    try {
      await store.dispatch('conversationLabels/update', {
        conversationId: conversation.id,
        labels: [...labels, label],
      });
      useAlert(t('CONVERSATION_SIDEBAR.AI_HANDOFF.SUCCESS'));
    } catch (error) {
      useAlert(t('CONVERSATION_SIDEBAR.AI_HANDOFF.ERROR'));
    }
  };

  return {
    returnToAI: conversation =>
      applyActionLabel(conversation, ACTION_LABELS.RETURN_TO_AI),
    resetConversation: conversation =>
      applyActionLabel(conversation, ACTION_LABELS.RESET),
  };
}
